// Reported image issues.
import { ReportedIssuesFilters, ReportedIssuesResponse } from '../../types/reportedIssues';
import { forgeRequest } from '../forgeRequest';
import { REPORTED_ISSUES_API_URL } from './endpoints';

export async function fetchReportedIssues(
  token: string,
  filters?: ReportedIssuesFilters
): Promise<ReportedIssuesResponse> {
  const params = new URLSearchParams();
  if (filters?.reason) params.set('reason', filters.reason);
  if (filters?.source) params.set('source', filters.source);
  if (filters?.imageId) params.set('image_id', filters.imageId);
  if (filters?.chainId != null) params.set('chain_id', String(filters.chainId));
  if (filters?.storeId != null) params.set('store_id', String(filters.storeId));
  if (filters?.skip != null) params.set('skip', String(filters.skip));
  if (filters?.limit != null) params.set('limit', String(filters.limit));
  const query = params.toString();
  return forgeRequest<ReportedIssuesResponse>(
    token,
    `${REPORTED_ISSUES_API_URL}${query ? `?${query}` : ''}`,
    'Error fetching reported issues'
  );
}
